import { gql } from "@apollo/client"

export const CREATE_OR_UPDATE_TAX_JAR_CONFIG = gql`
  mutation createOrUpdateTaxJarConfig($id: ID!, $taxJarConfig: InputTaxJarConfig!) {
    createOrUpdateTaxJarConfig(id: $id, taxJarConfig: $taxJarConfig) {
      id
    }
  }
`
